'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAgentResponderIfNecessary = exports.fetchAgentResponder = exports.fetchAgentResponderFailed = exports.fetchAgentResponderSucceeded = exports.fetchAgentResponderAction = undefined;

var _reduxActions = require('redux-actions');

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _fetchAgentResponder = require('../responders/clients/fetchAgentResponder');

var _Responder = require('conversations-schema/responders/records/Responder');

var _Responder2 = _interopRequireDefault(_Responder);

var _getResponderByIdAndType = require('conversations-schema/responders/operators/getResponderByIdAndType');

var _getResponders = require('../responders/selectors/getResponders');

var _senderTypeToAgentType = require('conversations-schema/operators/sender-type/senderTypeToAgentType');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var fetchAgentResponderAction = exports.fetchAgentResponderAction = (0, _reduxActions.createAction)(ActionTypes.FETCH_AGENT_RESPONDER);

var fetchAgentResponderSucceeded = exports.fetchAgentResponderSucceeded = (0, _reduxActions.createAction)(ActionTypes.FETCH_AGENT_RESPONDER_SUCCEEDED, function (_ref) {
  var agent = _ref.agent;
  return (0, _Responder2.default)(agent);
});

var fetchAgentResponderFailed = exports.fetchAgentResponderFailed = (0, _reduxActions.createAction)(ActionTypes.FETCH_AGENT_RESPONDER_FAILED);

var fetchAgentResponder = exports.fetchAgentResponder = function fetchAgentResponder(_ref2) {
  var senderId = _ref2.senderId,
      agentType = _ref2.agentType;

  return function (dispatch) {
    dispatch(fetchAgentResponderAction());
    return (0, _fetchAgentResponder.fetchAgentResponder)({ senderId: senderId, agentType: agentType }).then(function (agent) {
      dispatch(fetchAgentResponderSucceeded({ agent: agent }));
    }).catch(function (err) {
      return dispatch(fetchAgentResponderFailed(err));
    }).done();
  };
};

var fetchAgentResponderIfNecessary = exports.fetchAgentResponderIfNecessary = function fetchAgentResponderIfNecessary(_ref3) {
  var senderId = _ref3.senderId,
      senderType = _ref3.senderType;

  return function (dispatch, getState) {
    var responders = (0, _getResponders.getResponders)(getState());
    if ((0, _getResponderByIdAndType.getResponderByIdAndType)({
      responders: responders,
      senderId: senderId,
      senderType: senderType
    })) {
      return;
    }
    var agentType = (0, _senderTypeToAgentType.senderTypeToAgentType)(senderType);

    dispatch(fetchAgentResponder({ senderId: senderId, agentType: agentType }));
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/AgentResponderActions.js
// module id = 323
// module chunks = 2 3